export default function FooterBrand() {
  return (
    <div className="md:col-span-5">
      <img
        src="/brand/indiora-mark.png"
        alt="Indiora Journeys"
        className="h-32 md:h-36 w-auto object-contain -ml-2"
      />
      <div className="mt-6 font-serif text-4xl md:text-5xl tracking-[0.08em] uppercase font-semibold text-ivory leading-tight">
        Indiora<br />Journeys
      </div>
      <div className="mt-4 text-[10px] tracking-widest3 uppercase text-goldleaf">
        Unfold The Extraordinary
      </div>
      <p className="mt-10 max-w-md text-ivory/70 leading-relaxed font-light">
        Refined cultural journeys through India, Nepal, Bhutan, and Sri
        Lanka — designed for the discerning traveller who measures distance
        in moments, not miles.
      </p>
    </div>
  );
}
